<div style="padding: 16px">
  <div style="margin-bottom: 16px">
    <app-date-range-selector
      (dateRangeChange)="onRangeChange($event)"
      [dateRange]="rango"
    ></app-date-range-selector>
  </div>

  <app-tabla
    [datos]="cumplimientos"
    [columnas]="columnas"
    [paginatorArriba]="false"
    [totalCount]="cumplimientos?.length || 0"
    [emptyState]="{
      title: 'No hay mediciones en el rango seleccionado',
      subtitle:
        'Se registra una medición por cada vez que el vehículo hace un recorrido que tenga el cumplimiento activado.',
    }"
  ></app-tabla>
</div>
